import { useState, useEffect } from "react";
import useDarkMode from '../../hooks/useDarkMode';
import useThemeColor from "../../hooks/useThemeColor";
import { useSelector } from "react-redux";
import showErrorToast, { showSuccessToast } from "../../components/CustomComponents/toast/toast";
import axiosInstance from "../../config/axiosApi/axiosApi";
import APIs from "../../Constants/apis";
import CustomModal from "../../components/CustomComponents/modal/customModal";
import FormInput from "../../components/CustomComponents/Input/formInput";
import ToggleSwitch from "../../components/CustomComponents/Switchery/switchery";
import { appSettings } from "../../app/appSettingsSlice";

function PettyCashHeadModal({
  isModalOpen,
  setIsModalOpen,
  onHeadSubmit,
  compID,
  headToEdit = null,
}) {
  const [headData, setHeadData] = useState({
    name: "",
    active: true,
  });

  // Get app settings from Redux
  const appSettings = useSelector((state) => state.appSettings);
  const { appTheme } = appSettings;
  
  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();

  // Get theme color from centralized hook
  const themeColor = useThemeColor();

  

  useEffect(() => {
    if (headToEdit) {
      setHeadData({
        id: headToEdit.id,
        name: headToEdit.name,
        active: headToEdit.active,
      });
    } else {
      setHeadData({
        name: "",
        active: true,
      });
    }
  }, [headToEdit]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setHeadData({
      name: "",
      active: true,
    });
  };

  const handleSubmit = async () => {
    try {
      if (!headData.name || headData.name.trim().length === 0) {
        showErrorToast("Please Provide Valid Petty Cash Head Name");
        return;
      }

      const submitData = {
        ID: headToEdit ? headToEdit.id : 0,
        name: headData.name,
        active: headData.active,
        compID: compID,
        updateDateTime: new Date().toISOString(),
      };

      try {
        const response = headToEdit
          ? await axiosInstance.post(APIs.POST_PETTY_CASH_HEAD, submitData)
          : await axiosInstance.post(APIs.POST_PETTY_CASH_HEAD, submitData);

        if (response.data.status) {
          showSuccessToast(
            headToEdit
              ? "Petty Cash Head updated successfully."
              : "Petty Cash Head added successfully."
          );
          onHeadSubmit(submitData, !!headToEdit);
          setIsModalOpen(false);
          setHeadData({
            name: "",
            active: true,
          });
        } else {
          showErrorToast(response.data.message || "Operation failed.");
        }
      } catch (error) {
        showErrorToast("Something went wrong.");
        // Error silently
      }
    } catch (err) {
      showErrorToast("Something went wrong.");
    }
  }

  return (
    <CustomModal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      onSubmit={handleSubmit}
      title={headToEdit ? "Update Petty Cash Head" : "Add Petty Cash Head"}
      showButton={true}
      isCentered={true}
      submitButtonText={headToEdit ? "Update" : "Add"}
      themeColor={themeColor}
    >
      <div className="row g-3 mb-4">
        <div className="col-md-12">
          <FormInput
            label="Head Name"
            placeHolder="Enter Petty Cash Head Name"
            type="text"
            value={headData.name}
            onchange={(e) =>
              setHeadData({
                ...headData,
                name: e.target.value,
              })
            }
            required
          />
        </div>
        <div className="col-md-12">
          <div className="d-flex align-items-center m-3">
            <ToggleSwitch
              isChecked={headData.active}
              onToggle={(e) =>
                setHeadData({
                  ...headData,
                  active: e.target.checked,
                })
              }
              label="Active"
              name="active"
              themeColor={themeColor}
            />
          </div>
        </div>
      </div>
    </CustomModal>
  );
}

export default PettyCashHeadModal;